export const UPDATE_ORDER_PHONE = 'ordersSearch/UPDATE_ORDER_PHONE'
export const UPDATE_ORDER_ID = 'ordersSearch/UPDATE_ORDER_ID'
export const UPDATE_ORDER = 'ordersSearch/UPDATE_ORDER'